module.exports = __webpack_public_path__ + "img/allButton.2b177e0b.png";